/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaListMediaOutletsOverwriteRequest
 */
export interface PrtimesMediaListMediaOutletsOverwriteRequest {
    /**
     * 選択中のメディアのIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListMediaOutletsOverwriteRequest
     */
    selectedMediaOutletIds: Array<number>;
}

export function PrtimesMediaListMediaOutletsOverwriteRequestFromJSON(json: any): PrtimesMediaListMediaOutletsOverwriteRequest {
    return PrtimesMediaListMediaOutletsOverwriteRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListMediaOutletsOverwriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListMediaOutletsOverwriteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedMediaOutletIds': json['selected_media_outlet_ids'],
    };
}

export function PrtimesMediaListMediaOutletsOverwriteRequestToJSON(value?: PrtimesMediaListMediaOutletsOverwriteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected_media_outlet_ids': value.selectedMediaOutletIds,
    };
}

